import {Feature, isEnabled} from '../../../features'
import {ReportGroupingLevel} from '../../constants'
import $ from 'jquery'
import _ from 'underscore'
import {StaffPerformanceColumnsConfig, TimeApprovalStatus} from 'constants'
import StaffOutputReportEditConfigController from './StaffOutputReportEditConfigController'

export default class StaffOutputReportEditFormConfigController extends StaffOutputReportEditConfigController{}

StaffOutputReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function( reportParameters ){
    const result = $.extend({}, reportParameters);
    if (!isEnabled(Feature.UGR)){
        result.columnsConfig = StaffPerformanceColumnsConfig.USERS_ONLY;
    }
    if (!isEnabled(Feature.TTA)) {
        result.timeApprovalStatus = TimeApprovalStatus.BOTH;
    }
    if (!isEnabled(Feature.LVT)) {
        result.showLeaveTime = false;
    }
    if (!isEnabled(Feature.BTY))
    {
        const groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.BILLING_TYPE, [result.firstGroupingLevel, result.secondGroupingLevel], ReportGroupingLevel.CUSTOMER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }

    return result;
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/staffOutput/StaffOutputReportEditFormConfigController.js